// tslint:disable:variable-name

import { KeyValue } from "@angular/common";
import { IAbstractForm, IAbstractItem, IAbstractTableItem } from "./Iabstracttableitem";
import { IKeyValue } from "./ikeyvalue.interface";
import { IAuthor } from "./itheses.interface";

export class AbstractUserResource {
  constructor(
    public abstractId: string,
    public userId: number,
    public isActive: boolean,
  ) { }
}

export class AbstractUserResponse {
  id: string;
  abstractId: string;
  userName: string;
  isActive: boolean;
  updatedAt: string;
}

export class AbstractStatusResponse {
  id: string;
  abstractStatus: string;
  userName: string;
  message: string;
  updatedAt: string;
  isEmailSent: boolean
}

export class AbstractStatusNewForm {
  constructor(
  public  abstractId: string,
  public  abstractStatusId: number,
  public  message: string,
  public  isSendEmail: boolean
  ) {}

}

export class AbstractTableItem implements IAbstractTableItem {
  constructor(
    public id: string,
    public conferenceId: number,
    public thesesTitle: string,
    public fullNameMainAuthor: string,
    public publishDate: string,
    public lastStatus: any,
    public isLastStatusSent: boolean,
    public lastStatusComment: string,
    public users: string[],
    public conference: IKeyValue[],
    public isPdf: boolean,
    public isVideo: boolean,
    public videoLink: string,
    public lastUpdateDate: string
  ) { }
}

export class AbstractQueryResult {
  constructor(
    public totalItems: number,
    public page: number,
    public totalPages: number,
    public items: AbstractTableItem[]
  ) { }
}

export class Author implements IAuthor {
  constructor(
    public lastName: string,
    public firstName: string,
    public middleName: string = '',
    public contactEmail?: string,
    public workplace?: string,
  ) { }
}

export class AbstractItem implements IAbstractItem {
  public id: string;
  public lastName: string;
  public firstName: string;
  public middleName: string;
  public contactEmail: string;
  public workplace: string;
  public otherAuthors: Author[];
  public thesesTitle: string;
  public thesesTarget: string;
  public thesesMaterials: string;
  public thesesResults: string;
  public thesesConclusions: string;
  public createdAt: string;
  public updatedAt: string;
  public conferenceTypeId?: number;
  public conferenceTypeName: string;
  public personId: number;
  public lastStatus: string;
  public posterPath: string;
  public videoLink: string;

  constructor(
    _id: string,
    _lastName: string,
    _firstName: string,
    _middleName: string,
    _contactEmail: string,
    _workplace: string,
    _otherAuthors: Author[],
    _thesesTitle: string,
    _thesesTarget: string,
    _thesesMaterials: string,
    _thesesResults: string,
    _thesesConclusions: string,
    _createdAt: string,
    _updatedAt: string,
    _conferenceTypeId?: number,
    _conferenceTypeName?: string,
    _posterPath?: string,
    _videoLink?: string
  ) {
    this.id = _id;
    this.lastName = _lastName;
    this.firstName = _firstName;
    this.middleName = _middleName;
    this.contactEmail = _contactEmail;
    this.workplace = _workplace;
    this.otherAuthors = _otherAuthors;
    this.thesesTitle = _thesesTitle;
    this.thesesTarget = _thesesTarget;
    this.thesesMaterials = _thesesMaterials;
    this.thesesResults = _thesesResults;
    this.thesesConclusions = _thesesConclusions;
    this.createdAt = _createdAt;
    this.updatedAt = _updatedAt;
    this.conferenceTypeId = _conferenceTypeId;
    this.conferenceTypeName = _conferenceTypeName;
    this.posterPath = _posterPath;
    this.videoLink = _videoLink;
  }
}

export interface AbstractReviewStatusResource {
  status: string;
  comment: string;
  lastDate: string;
}

export class AbstractItemReviewForm {
  constructor(public review: AbstractItemReview, public comment: string) {

  }
}

export class AbstractItemReview extends AbstractItem {
  public conferenceName: string;
  public statuses: AbstractReviewStatusResource[];
  constructor(
    _id: string,
    _lastName: string,
    _firstName: string,
    _middleName: string,
    _contactEmail: string,
    _workplace: string,
    _otherAuthors: Author[],
    _thesesTitle: string,
    _thesesTarget: string,
    _thesesMaterials: string,
    _thesesResults: string,
    _thesesConclusions: string,
    _createdAt: string,
    _updatedAt: string,
    _conferenceName: string,
    _conferenceTypeId?: number,
    _posterPath?: string,
    _videoLink?: string
  ) {
    super(
      _id,
      _lastName,
      _firstName,
      _middleName,
      _contactEmail,
      _workplace,
      _otherAuthors,
      _thesesTitle,
      _thesesTarget,
      _thesesMaterials,
      _thesesResults,
      _thesesConclusions,
      _createdAt,
      _updatedAt,
      _conferenceTypeId,
      _posterPath,
      _videoLink
    );

    this.conferenceName = _conferenceName;
  }
}

export class AbstractForm implements IAbstractForm {
  constructor(
    public lastName: string,
    public firstName: string,
    public middleName: string,
    public contactEmail: string,
    public workplace: string,
    public otherAuthors: Author[],
    public thesesTitle: string,
    public thesesTarget: string,
    public thesesMaterials: string,
    public thesesResults: string,
    public thesesConclusions: string
  ) { }
}

export interface PersonAbstractResource {
  id: string;
  personId: number;
  conferenceId: number;
  conferenceName: string;
  title: string;
  lastStatus: string;
  isPdf: boolean;
  isVideo: boolean;
  videoLink: string
}


export class AbstractStatusForm {
  constructor(
    public status: string,
    public message: string,
    public isSendEmail: boolean
  ) {}
}

export class AbstractVideoLinkForm {
  constructor(public link: string) {}
}

export class AbstractStaticsticsRecord {
  constructor(
    public name: string,
    public items: KeyValue<string, number>[]
  ) {}
}
